import { render, staticRenderFns } from "./MbChoseTheme.vue?vue&type=template&id=4616d191&"
import script from "./MbChoseTheme.vue?vue&type=script&lang=js&"
export * from "./MbChoseTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports